export default __webpack_public_path__ + "static/media/LogoBlack.e113eda5.svg";